/* ../lib/components/parts/MockTree/MockTree.svelte generated by Svelte v3.18.2 */
import {
	SvelteComponent,
	append,
	attr,
	bubble,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import { createEventDispatcher } from "svelte";
import { reflectSwitchData } from "../../../utils/patterns";

function add_css() {
	var style = element("style");
	style.id = "svelte-1kubbru-style";
	style.textContent = ".tree-ul.svelte-1kubbru.svelte-1kubbru{display:grid}.tree-li.svelte-1kubbru.svelte-1kubbru{display:grid;grid-template-columns:auto auto 1fr;grid-template-areas:'. . description'\r\n      '. . .';justify-content:start;align-items:center;grid-column-gap:6px}.tree-li.has-switch.svelte-1kubbru.svelte-1kubbru{grid-template-columns:auto auto auto 1fr;grid-template-areas:'. . . description'\r\n      '. . . .'}.open-close-icon.svelte-1kubbru.svelte-1kubbru{cursor:pointer;user-select:none;width:20px;height:20px;border-radius:4px;display:grid;justify-content:center;align-items:center;font-size:16px;color:#555;line-height:0px;font-weight:bold;font-family:sans-serif;border:solid 2px #555}.open-close-icon.svelte-1kubbru.svelte-1kubbru:hover{background-color:#ccc}.open-close-icon.hide.svelte-1kubbru.svelte-1kubbru{visibility:hidden}.action.svelte-1kubbru.svelte-1kubbru{cursor:pointer;color:blue;padding:2px 4px;margin-top:2px;margin-bottom:2px;box-sizing:border-box;line-height:1.15;text-decoration:none}.action.svelte-1kubbru.svelte-1kubbru:hover{opacity:0.4}.action.executed.svelte-1kubbru.svelte-1kubbru{border:1px solid #555;border-radius:4px}small.svelte-1kubbru.svelte-1kubbru{grid-area:description;white-space:pre-line;margin-left:6px}.child.svelte-1kubbru.svelte-1kubbru{margin-left:10px;grid-column:1 / -1}.switch-ul.svelte-1kubbru.svelte-1kubbru{display:grid;grid-auto-flow:column}.switch-ul.svelte-1kubbru li.svelte-1kubbru{cursor:pointer;border:1px solid rgba(255, 128, 0, 0.6);padding:0 6px;text-align:center;display:inline-block;line-height:1.15}.switch-ul.svelte-1kubbru li.selected.svelte-1kubbru{background-color:yellow}";
	append(document.head, style);
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];
	return child_ctx;
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (144:6) {#if item.hasSwitch}
function create_if_block_1(ctx) {
	let ul;
	let each_value_1 = /*item*/ ctx[9].switchData;
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	return {
		c() {
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(ul, "class", "switch-ul svelte-1kubbru");
		},
		m(target, anchor) {
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}
		},
		p(ctx, dirty) {
			if (dirty & /*treeData, onSwitch*/ 5) {
				each_value_1 = /*item*/ ctx[9].switchData;
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (146:10) {#each item.switchData as switchItem}
function create_each_block_1(ctx) {
	let li;
	let t0_value = /*switchItem*/ ctx[12].name + "";
	let t0;
	let t1;
	let dispose;

	function click_handler_2(...args) {
		return /*click_handler_2*/ ctx[7](/*item*/ ctx[9], /*switchItem*/ ctx[12], ...args);
	}

	return {
		c() {
			li = element("li");
			t0 = text(t0_value);
			t1 = space();
			attr(li, "class", "svelte-1kubbru");
			toggle_class(li, "selected", /*item*/ ctx[9].selected.name === /*switchItem*/ ctx[12].name);
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, t0);
			append(li, t1);
			dispose = listen(li, "click", click_handler_2);
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty & /*treeData*/ 1 && t0_value !== (t0_value = /*switchItem*/ ctx[12].name + "")) set_data(t0, t0_value);

			if (dirty & /*treeData*/ 1) {
				toggle_class(li, "selected", /*item*/ ctx[9].selected.name === /*switchItem*/ ctx[12].name);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			dispose();
		}
	};
}

// (158:6) {#if item.isOpen}
function create_if_block(ctx) {
	let div;
	let current;

	const mocktree = new MockTree({
			props: { treeData: /*item*/ ctx[9].treeData }
		});

	mocktree.$on("actionclick", /*actionclick_handler*/ ctx[8]);

	return {
		c() {
			div = element("div");
			create_component(mocktree.$$.fragment);
			attr(div, "class", "child svelte-1kubbru");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(mocktree, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const mocktree_changes = {};
			if (dirty & /*treeData*/ 1) mocktree_changes.treeData = /*item*/ ctx[9].treeData;
			mocktree.$set(mocktree_changes);
		},
		i(local) {
			if (current) return;
			transition_in(mocktree.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(mocktree.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(mocktree);
		}
	};
}

// (126:2) {#each treeData as item}
function create_each_block(ctx) {
	let li;
	let div;
	let t0_value = (/*item*/ ctx[9].isOpen ? "-" : "+") + "";
	let t0;
	let t1;
	let a;
	let t2_value = /*item*/ ctx[9].name + "";
	let t2;
	let a_data_mock_name_tree_value;
	let a_href_value;
	let t3;
	let t4;
	let small;
	let t5_value = /*item*/ ctx[9].description + "";
	let t5;
	let t6;
	let t7;
	let li_class_value;
	let current;
	let dispose;

	function click_handler(...args) {
		return /*click_handler*/ ctx[5](/*item*/ ctx[9], ...args);
	}

	function click_handler_1(...args) {
		return /*click_handler_1*/ ctx[6](/*item*/ ctx[9], ...args);
	}

	let if_block0 = /*item*/ ctx[9].hasSwitch && create_if_block_1(ctx);
	let if_block1 = /*item*/ ctx[9].isOpen && create_if_block(ctx);

	return {
		c() {
			li = element("li");
			div = element("div");
			t0 = text(t0_value);
			t1 = space();
			a = element("a");
			t2 = text(t2_value);
			t3 = space();
			if (if_block0) if_block0.c();
			t4 = space();
			small = element("small");
			t5 = text(t5_value);
			t6 = space();
			if (if_block1) if_block1.c();
			t7 = space();
			attr(div, "class", "open-close-icon svelte-1kubbru");
			toggle_class(div, "hide", !/*item*/ ctx[9].hasChild);
			attr(a, "data-mock-name-tree", a_data_mock_name_tree_value = /*item*/ ctx[9].nameTree);
			attr(a, "href", a_href_value = getMockUrl(/*item*/ ctx[9]));
			attr(a, "class", "action svelte-1kubbru");
			toggle_class(a, "executed", /*item*/ ctx[9].lastExecuted);
			attr(small, "class", "svelte-1kubbru");
			attr(li, "class", li_class_value = "tree-li " + (/*item*/ ctx[9].hasSwitch ? "has-switch" : "") + " svelte-1kubbru");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, div);
			append(div, t0);
			append(li, t1);
			append(li, a);
			append(a, t2);
			append(li, t3);
			if (if_block0) if_block0.m(li, null);
			append(li, t4);
			append(li, small);
			append(small, t5);
			append(li, t6);
			if (if_block1) if_block1.m(li, null);
			append(li, t7);
			current = true;

			dispose = [
				listen(div, "click", click_handler),
				listen(a, "click", prevent_default(click_handler_1))
			];
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if ((!current || dirty & /*treeData*/ 1) && t0_value !== (t0_value = (/*item*/ ctx[9].isOpen ? "-" : "+") + "")) set_data(t0, t0_value);

			if (dirty & /*treeData*/ 1) {
				toggle_class(div, "hide", !/*item*/ ctx[9].hasChild);
			}

			if ((!current || dirty & /*treeData*/ 1) && t2_value !== (t2_value = /*item*/ ctx[9].name + "")) set_data(t2, t2_value);

			if (!current || dirty & /*treeData*/ 1 && a_data_mock_name_tree_value !== (a_data_mock_name_tree_value = /*item*/ ctx[9].nameTree)) {
				attr(a, "data-mock-name-tree", a_data_mock_name_tree_value);
			}

			if (!current || dirty & /*treeData*/ 1 && a_href_value !== (a_href_value = getMockUrl(/*item*/ ctx[9]))) {
				attr(a, "href", a_href_value);
			}

			if (dirty & /*treeData*/ 1) {
				toggle_class(a, "executed", /*item*/ ctx[9].lastExecuted);
			}

			if (/*item*/ ctx[9].hasSwitch) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(li, t4);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if ((!current || dirty & /*treeData*/ 1) && t5_value !== (t5_value = /*item*/ ctx[9].description + "")) set_data(t5, t5_value);

			if (/*item*/ ctx[9].isOpen) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
					transition_in(if_block1, 1);
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(li, t7);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*treeData*/ 1 && li_class_value !== (li_class_value = "tree-li " + (/*item*/ ctx[9].hasSwitch ? "has-switch" : "") + " svelte-1kubbru")) {
				attr(li, "class", li_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(li);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let ul;
	let current;
	let each_value = /*treeData*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(ul, "class", "tree-ul svelte-1kubbru");
		},
		m(target, anchor) {
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*treeData, onSwitch, getMockUrl, onActionClick, toggleItem*/ 15) {
				each_value = /*treeData*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(ul, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
		}
	};
}

function getMockUrl(treeItem) {
	const actionsJson = JSON.stringify(treeItem.actions);
	const mockUrl = `${treeItem.url}?__amMocktimes__=${actionsJson}`;
	return mockUrl;
}

function instance($$self, $$props, $$invalidate) {
	let { treeData } = $$props;
	const dispatch = createEventDispatcher();

	function onActionClick(treeItem) {
		dispatch("actionclick", { mockUrl: getMockUrl(treeItem), treeItem });
	}

	function onSwitch(treeItem, switchItem) {
		reflectSwitchData(treeItem, switchItem);
		$$invalidate(0, treeData);
	}

	function toggleItem(treeDataItem) {
		treeDataItem.isOpen = !treeDataItem.isOpen;
		$$invalidate(0, treeData);
	}

	const click_handler = item => toggleItem(item);
	const click_handler_1 = item => onActionClick(item);
	const click_handler_2 = (item, switchItem) => onSwitch(item, switchItem);

	function actionclick_handler(event) {
		bubble($$self, event);
	}

	$$self.$set = $$props => {
		if ("treeData" in $$props) $$invalidate(0, treeData = $$props.treeData);
	};

	return [
		treeData,
		onActionClick,
		onSwitch,
		toggleItem,
		dispatch,
		click_handler,
		click_handler_1,
		click_handler_2,
		actionclick_handler
	];
}

class MockTree extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1kubbru-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { treeData: 0 });
	}
}

export default MockTree;